<template>
    <multiselect
        v-model="status"
        :options="states"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="true"
        placeholder="Estado"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {states} from '@/constants/receipt-constants';

    export default {
        name: "ReceiptStatusSelector",
        components: {
            Multiselect
        },
        props: {
            value: String
        },
        data: function () {
            return {
                status: !!this.value ? this.findStatusByKey(this.value) : null
            }
        },
        computed: {
            states() {
                return states;
            }
        },
        methods: {
            findStatusByKey(key) {
                return states.find(status => (status.key === key));
            },
            notifyChange(status) {
                if (!!status) {
                    this.$emit('input', status.key);
                } else {
                    this.$emit('input', null);
                }
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.status = this.findStatusByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>